module.exports = __webpack_public_path__ + "img/education_img_bg.49740537.png";